import PrintPreferenceTabs from "../templete/PrintPreferenceTabs";
const BillingInvoice = () => {
  return (
    <PrintPreferenceTabs type="billing_invoice"></PrintPreferenceTabs>
  );
};
export default BillingInvoice;
